/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * {Document Title}
 * {Description}
 */

(function (window, $) {
	'use strict';
	var document = window.document;

	var jsDoClick = {

		init: function () {
			// add click event on parent li, div, etc ... with a <a class="js-do-click-target"></a> has children
			$(".js-do-click").click(function (event) {
				var closest_targed = $(this).find(".js-do-click-target");
				var target = closest_targed.attr('target');
				var url = closest_targed.attr('href');
				if (typeof target !== typeof undefined && target !== false) {
					window.open(url);
				} else {
					window.location.href = url;
				}
			});

			// Change le tab en cours dans dossier vedette
			$('.select-menu select').change(function(){
				$('.featured-container_sidebar a[href="' + $(this).val() + '"]').tab('show');
			});
		}
	};

	$(document).ready(function () {
		jsDoClick.init();
	});

})(window,jQuery);


